export type VmNameKind = 'hyperV' | 'proxmox';

const ProxmoxVmNameMaxLength = 63;
const HyperVVmNameMaxLength = 100;
const ProxmoxAllowedChar = /[A-Za-z0-9.-]/;
const HyperVForbiddenChar = /[\\/:*?"<>|]/;

export function toValidVmName(value: string, kind: VmNameKind): string {
  const source = typeof value === 'string' ? value : '';

  return kind === 'proxmox' ? toValidProxmoxVmName(source) : toValidHyperVVmName(source);
}

function toValidProxmoxVmName(value: string): string {
  const labels = replaceChars(value, isForbiddenProxmoxChar)
    .split('.')
    .map((label) => label.replace(/^-+/, '').replace(/-+$/, ''))
    .filter(Boolean);

  return trimProxmoxEdges(labels.join('.').slice(0, ProxmoxVmNameMaxLength));
}

function toValidHyperVVmName(value: string): string {
  const replaced = trimHyperVEdges(replaceChars(value, isForbiddenHyperVChar));

  return trimHyperVEdges(replaced.slice(0, HyperVVmNameMaxLength));
}

function isForbiddenProxmoxChar(char: string): boolean {
  return !ProxmoxAllowedChar.test(char);
}

function isForbiddenHyperVChar(char: string): boolean {
  const code = char.codePointAt(0);

  return code <= 0x1f || code === 0x7f || HyperVForbiddenChar.test(char);
}

function replaceChars(value: string, isForbidden: (char: string) => boolean): string {
  return Array.from(value)
    .map((char) => (isForbidden(char) ? '-' : char))
    .join('');
}

function trimProxmoxEdges(value: string): string {
  return value.replace(/^[-.]+/, '').replace(/[-.]+$/, '');
}

function trimHyperVEdges(value: string): string {
  return value.replace(/^[ .]+/, '').replace(/[ .]+$/, '');
}
